module.exports = __webpack_public_path__ + "img/logo.4b3d367a.png";